import { registerApplication, start } from 'single-spa'
import appList from '@/shared/micro-frontend/app-list.js'
import activeApp from '@/shared/micro-frontend/active-app.js'

export default function () {
  appList.forEach((app) => {
    const { id, importFunction } = app
    registerApplication(id, importFunction, () => activeApp() === id)
  })

  // Scrolls browser to top on page change
  window.addEventListener('single-spa:routing-event', () => {
    setTimeout(() => {
      document.documentElement.scrollTop = 0
    }, 0)
  })

  start()
}
